import styled from "styled-components";

export const VersionHistoryWrapper = styled.div`
  padding: 0 24px 24px;
  background-color: #ffffff;
  font-family: "Readex Pro", sans-serif;
`;

export const VersionHistoryTitle = styled.div`
  color: #767676;
  font-size: 12px;
  font-family: Readex Pro;
  font-weight: 300;
  line-height: 15.6px;
  margin-bottom: 12px;
`;

export const VersionTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const VersionTableHead = styled.thead`
  position: sticky;
  top: 0;
  background-color: #ffffff;
`;

export const VersionTableHeaderRow = styled.tr`
  border-bottom: 1px solid #ddd;
`;

export const VersionTableHeader = styled.th`
  padding: 8px;
  text-align: left;
  font-size: 12px;
  font-weight: 400;
  color: #000000;
  white-space: nowrap;
`;

export const VersionTableBody = styled.tbody``;

export const VersionTableRow = styled.tr`
  border-bottom: 1px solid #ddd;

  &:hover {
    background-color: rgba(221, 221, 221, 0.5);
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const VersionTableCell = styled.td`
  padding: 8px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19.6px;
  color: #1b1b1b;
  white-space: nowrap;
`;

export const VersionNumber = styled.span`
  color: #3f7f7d;
  font-size: 14px;
  font-weight: 400;
`;

export const EmptyState = styled.div`
  padding: 24px 8px;
  color: #a4a4a4;
  font-size: 14px;
  font-family: "Readex Pro", sans-serif;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px;
`;
